import { type Role, Roles } from "api/schemas/shared";

export function getRolePathPrefix(role: Role): string {
  switch (role) {
    case Roles.ClinicPartner:
      return "/clinic_partners";
    case Roles.Therapist:
      return "/therapists";
    default:
      return "/therapists";
  }
}
